
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M501.3 10.4V10h-3.7v.5L67 124.6l25.2 456c0 3 0 60.6 18.4 95.2 92.7 174.2 312.3 280 382.7 311.3.2.1 2.3 1 4.4 1.8v1c.4 0 1-.2 1.7-.4.8.2 1.5.4 1.9.4h.1v-1.1c1.7-.7 3.3-1.5 3.4-1.6 70.4-31.3 290-137.2 382.7-311.3 18.4-34.6 20.3-92.2 20.4-95.2l25.2-456L501.3 10.4zM216.7 221.9c0-12.4 10.1-22.5 22.5-22.5H453c12.4 0 22.5 10.1 22.5 22.5v101.2c0 12.4-10.1 22.5-22.5 22.5H239.2c-12.4 0-22.5-10.1-22.5-22.5V221.9zm0 191.3c0-12.4 10.1-22.5 22.5-22.5h67.5c12.4 0 22.5 10.1 22.5 22.5v101.2c0 12.4-10.1 22.5-22.5 22.5h-67.5c-12.4 0-22.5-10.1-22.5-22.5V413.2zm258.8 292.5c0 12.4-10.1 22.5-22.5 22.5H239.2c-12.4 0-22.5-10.1-22.5-22.5V604.4c0-12.4 10.1-22.5 22.5-22.5H453c12.4 0 22.5 10.1 22.5 22.5v101.3zm-78.8-168.8c-12.4 0-22.5-10.1-22.5-22.5V413.2c0-12.4 10.1-22.5 22.5-22.5h202.5c12.4 0 22.5 10.1 22.5 22.5v101.2c0 12.4-10.1 22.5-22.5 22.5H396.7zm382.5 168.8c0 12.4-10.1 22.5-22.5 22.5H543c-12.4 0-22.5-10.1-22.5-22.5V604.4c0-12.4 10.1-22.5 22.5-22.5h213.7c12.4 0 22.5 10.1 22.5 22.5v101.3zm0-191.3c0 12.4-10.1 22.5-22.5 22.5h-67.5c-12.4 0-22.5-10.1-22.5-22.5V413.2c0-12.4 10.1-22.5 22.5-22.5h67.5c12.4 0 22.5 10.1 22.5 22.5v101.2zm0-191.2c0 12.4-10.1 22.5-22.5 22.5H543c-12.4 0-22.5-10.1-22.5-22.5V221.9c0-12.4 10.1-22.5 22.5-22.5h213.7c12.4 0 22.5 10.1 22.5 22.5v101.3z"}})])
          )
        }
      }
    